import { KeyMap } from './KeyMap';
import { Model } from './Model';

export enum CompanyLicenseType {
  OIC_PACOTE = 'OIC_Pacote'
}

export class Company extends Model<Company> {
  public id: number;
  public cnpj: string;
  public razaoSocial: string;
  public codigoERP: string;
  public organizationId: number;
  public accountingId: number;
  public nomeCompleto: string;
  public nomeResumido: string;
  public nomeContabilidade: string;
  public tokenAssaas?: string;
  public tokenErpBasePag?: string;
  public status?: number;
  public observacao?: string;
  public detalheStatus?: string;
  public erpContabil: string;
  public emailResponsavel: string;
  public criadoPor: string

  public instrucoesFechamentoPagamentos?: string
  public instrucoesFechamentoRecebimentos?: string

  public tipoLicenca: CompanyLicenseType;
  public ativo: boolean;

  public empresaInativa?: boolean;

  public criadoOic40: boolean;
  public layoutsPadroes?: string

  constructor(map?: KeyMap<Company>) {
    super(map);
    this.erpContabil = this.erpContabil || '';
  }

  public get narration(): string {
      return `Empresa ${this.razaoSocial}`;
  }

}

export class ReceitaCompany {
  public cnpj: string;
  public nome: string;
  public fantasia: string;
}

export class SFCompany {
    Id: string;
    Name: string;
    CNPJ__c: string;
    Codigo_Empresa_ERP__C: string;
    Nome_Resumido__c: string;
    nomeCompleto: string;
    Contabilidade__c: string;
    Empresa__c: string;
}